/**
 * Stack of three overlapping card frames, for the teasers' stacked-card look.
 *
 * The top card holds the caller's content; two offset frames peek out below
 * it. Used with real comment previews on teaser surfaces and with
 * `SkeletonCommentInCardStack` while one loads.
 */

import { createThemedStyles } from '@repo/theme/styles';
import React from 'react';
import type { DimensionValue } from 'react-native';
import { View } from 'react-native';

export type CardStackProps = { children: React.ReactNode; width?: DimensionValue };

export function CardStack({ children, width }: CardStackProps) {
    const s = useCardStackStyles();
    return (
        <View style={{ width: width }}>
            <View style={s.topCard}>{children}</View>
            <View style={s.secondCard} />
            <View style={s.thirdCard} />
        </View>
    );
}

const useCardStackStyles = createThemedStyles((tokens) => ({
    topCard: {
        backgroundColor: tokens.colors.colorSurfacePrimary,
        boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.05)' as any,
        borderWidth: 1,
        borderColor: tokens.colors.colorBorderPrimary,
        borderRadius: 6,
        marginBottom: 16,
    },
    secondCard: {
        backgroundColor: tokens.colors.colorSurfacePrimary,
        boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.05)' as any,
        borderWidth: 1,
        borderColor: tokens.colors.colorBorderPrimary,
        borderRadius: 6,
        opacity: 0.8,
        zIndex: -1,
        height: 20,
        position: 'absolute',
        left: 10,
        right: 10,
        bottom: 8,
    },
    thirdCard: {
        backgroundColor: tokens.colors.colorSurfacePrimary,
        boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.05)' as any,
        borderWidth: 1,
        borderColor: tokens.colors.colorBorderPrimary,
        borderRadius: 6,
        opacity: 0.6,
        zIndex: -2,
        height: 20,
        position: 'absolute',
        left: 20,
        right: 20,
        bottom: 0,
    },
}));
